import { render } from "./yk.vue?vue&type=template&id=5a964d42&scoped=true"
import script from "./yk.vue?vue&type=script&lang=js"
export * from "./yk.vue?vue&type=script&lang=js"

import "./yk.vue?vue&type=style&index=0&id=5a964d42&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a964d42"]])

export default __exports__